module.exports = __webpack_public_path__ + "static/media/Group9260.f973374f.png";